import {useEffect} from "react";

const useOutsideAlerter = (ref, callback) => {
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				ref.current &&
				!ref.current.contains(event.target) &&
				!ref.current.isEqualNode(event.target)

			) {
				if (typeof callback === 'function') {
					callback();
				}
			}
		}

		document.addEventListener('mousedown', handleClickOutside);
		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
			document.removeEventListener('click', handleClickOutside);
		};
	}, [ref, callback]);
}

export default useOutsideAlerter;
